/** biome-ignore-all lint/a11y/noStaticElementInteractions: <explanation> */
import cx from "classnames";
import { useAtomValue } from "jotai";
import { canv } from "@/canv/global";
import { arrowToolMenuLineType } from "@/interface/AppStore";
import { VStack } from "@/shared/ui/Stack";
import CurvedIcon from "../../../icons/CurvedIcon.svg?react";
import QuadraticIcon from "../../../icons/QuadraticIcon.svg?react";
import StraightIcon from "../../../icons/StraightIcon.svg?react";
import styles from "./ArrowMenu.module.css";

const modes = [
    { mode: "straight", icon: <StraightIcon /> },
    { mode: "quadratic", icon: <QuadraticIcon /> },
    { mode: "curved", icon: <CurvedIcon /> },
];

export const ArrowMenu = () => {
    const activeType = useAtomValue(arrowToolMenuLineType);

    const handleSelect = (type: string) => {
        canv.toolBox.Tools.arrowTool.setLineType(type);
    };

    return (
        <VStack gap={5} className={styles.arrowToolSubMenu}>
            {modes.map((item) => {
                return (
                    <div
                        key={item.mode}
                        className={cx(styles.arrowToolSubMenuContainer, {
                            [styles.arrowToolSubMenuSelected]: activeType === item.mode,
                        })}
                        onClick={() => handleSelect(item.mode)}
                    >
                        {item.icon}
                    </div>
                );
            })}
        </VStack>
    );
};
